import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";

import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import Navigation from "../components/Navigation/Navigation";

import Gallery from "../components/Gallery/Gallery";
import { useEffect } from "react";

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return null;
};

const App = () => {
  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <Header />

        <Routes>
          <Route
            path="przygotowania"
            element={<Gallery type="przygotowania" />}
          />
          <Route path="slub" element={<Gallery type="slub" />} />
          <Route path="wesele" element={<Gallery type="wesele" />} />
          <Route path="/*" element={<Navigation />} />
          <Route element={<Navigation />} />
        </Routes>

        <Footer />
      </BrowserRouter>
    </>
  );
};

export default App;
